/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter, NavLink, Route, Switch } from 'react-router-dom';
import cn from 'classnames';
import { colors } from 'utils/colors';
import { Storage } from 'actions';
import Execute from '../../Portfolio/Analytics/Execute';
import Overview from '../../Portfolio/Analytics/Overview';
import Diversification from '../../Portfolio/Analytics/Diversification';
import AssetClass from '../../Portfolio/Analytics/Diversification/AssetClass';
import IndividualAsset from '../../Portfolio/Analytics/Diversification/IndividualAsset';
import Region from '../../Portfolio/Analytics/Diversification/Region';
import GlobalSector from '../../Portfolio/Analytics/Diversification/GlobalSector';
import MacroFactor from '../../Portfolio/Analytics/Diversification/MacroFactor';
import EquityStyle from '../../Portfolio/Analytics/Diversification/EquityStyle';
import Fees from '../../Portfolio/Analytics/Fees';
import Income from '../../Portfolio/Analytics/Income';
import Performance from '../../Portfolio/Analytics/Performance';
import Downside from '../../Portfolio/Analytics/Downside';
import PDF from '../../Portfolio/PDF';
import { translation } from '../../Translation/scorecard';

@withRouter
@connect((state) => ({
  analytics: state.Analytics,
  check_history:
    state.Storage['pwpa-check-history'] === undefined
      ? true
      : state.Storage['pwpa-check-history'],
  pwpaPortfolio: state.Storage['pwpa-portfolio'],
  pwpaHasExcludeHolding: state.Storage['pwpa-has-exclude-holding'],
  language: state.Storage.language,
}))
export default class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDiversification: false,
      ableHover: false,
      initHasExcludedHolding: null,
    };
  }

  componentDidMount() {
    const { openDiversification } = this.state;
    const { analytics, pwpaHasExcludeHolding, dispatch } = this.props;
    const hasExcludedHolding =
      analytics && analytics.data
        ? analytics.data.tickersOriginal.find((holding) => holding.isExcluded)
        : null;

    if (window.location.pathname.split('/').indexOf('diversification') !== -1) {
      if (!openDiversification) {
        this.setState({ openDiversification: true });
      }
    } else if (openDiversification) {
      this.setState({ openDiversification: false });
    }

    if (pwpaHasExcludeHolding === undefined) {
      dispatch(
        Storage.setItem('pwpa-has-exclude-holding', !!hasExcludedHolding)
      );
      this.setState({ initHasExcludedHolding: !!hasExcludedHolding });
    } else {
      this.setState({ initHasExcludedHolding: pwpaHasExcludeHolding });
    }
  }

  componentDidUpdate() {
    const { ableHover } = this.state;

    if (window.location.pathname.split('/').indexOf('diversification') !== -1) {
      if (!ableHover) {
        this.setAbleHover(true);
      }
    } else if (ableHover) {
      this.setAbleHover(false);
    }
  }

  setAbleHover(value) {
    this.setState({ ableHover: value });
  }

  render() {
    const {
      analytics,
      dispatch,
      history,
      check_history,
      pwpaPortfolio,
      language,
    } = this.props;
    const { openDiversification, ableHover, initHasExcludedHolding } =
      this.state;

    return (
      <Container
        onClick={() =>
          openDiversification
            ? this.setState({ openDiversification: false })
            : null
        }
      >
        <div
          style={{
            position: 'relative',
            display: `${
              history.location.pathname.includes('pdf') ? 'none' : 'block'
            }`,
          }}
        >
          <Tab to="/scorecard/overview">
            {translation[language].MENU.OVERVIEW}
          </Tab>
          <Tab to="/scorecard/performance">
            {translation[language].MENU.PERFORMANCE}
          </Tab>
          <Tab to="/scorecard/downside">
            {translation[language].MENU.DOWNSIDE}
          </Tab>
          <Tab to="/scorecard/fees">{translation[language].MENU.FEES}</Tab>
          <Tab to="/scorecard/income">{translation[language].MENU.INCOME}</Tab>
          {
            /* eslint-disable */
            <SubMenu open={openDiversification} ableHover={ableHover}>
              <li
                className={cn({
                  active:
                    window.location.pathname
                      .split('/')
                      .indexOf('diversification') !== -1,
                })}
                onClick={() =>
                  openDiversification
                    ? null
                    : this.setState({ openDiversification: true })
                }
              >
                <NavLink to="/scorecard/diversification">
                  {translation[language].MENU.DIVERSIFICATION}
                </NavLink>
              </li>
              <li>
                <NavLink to="/scorecard/diversification/asset_class">
                  {translation[language].MENU.ASSET}
                </NavLink>
              </li>
              <li>
                <NavLink to="/scorecard/diversification/individual_asset">
                  {translation[language].MENU.INDIVIDUAL}
                </NavLink>
              </li>
              <li>
                <NavLink to="/scorecard/diversification/region">
                  {translation[language].MENU.REGION}
                </NavLink>
              </li>
              <li>
                <NavLink to="/scorecard/diversification/global_sector">
                  {translation[language].MENU.GLOBAL}
                </NavLink>
              </li>
              <li>
                <NavLink to="/scorecard/diversification/macro_factor">
                  {translation[language].MENU.MACRO}
                </NavLink>
              </li>
              <li>
                <NavLink to="/scorecard/diversification/equity_style">
                  {translation[language].MENU.EQUITY}
                </NavLink>
              </li>
            </SubMenu>
            /* eslint-enable */
          }
        </div>

        <Switch>
          <Route
            path="/scorecard/overview"
            render={(props) => (
              <Overview
                dispatch={dispatch}
                analytics={analytics}
                benchmark={analytics.benchmark}
                objective={analytics.objective}
                initHasExcludedHolding={initHasExcludedHolding}
                check_history={check_history}
                pwpaPortfolio={pwpaPortfolio}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/performance"
            render={(props) => (
              <Performance
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                user_region="CA"
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/downside"
            render={(props) => (
              <Downside
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/fees"
            render={(props) => (
              <Fees
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/income"
            render={(props) => (
              <Income
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            exact
            path="/scorecard/diversification"
            render={(props) => (
              <Diversification
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/diversification/asset_class"
            render={(props) => (
              <AssetClass
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/diversification/individual_asset"
            render={(props) => (
              <IndividualAsset
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/diversification/region"
            render={(props) => (
              <Region
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/diversification/global_sector"
            render={(props) => (
              <GlobalSector
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/diversification/macro_factor"
            render={(props) => (
              <MacroFactor
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/diversification/equity_style"
            render={(props) => (
              <EquityStyle
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route
            path="/scorecard/execute"
            render={(props) => (
              <Execute
                dispatch={dispatch}
                benchmark={analytics.benchmark}
                data={analytics.data}
                objective={analytics.objective}
                {...props}
              />
            )}
          />
          <Route path="/scorecard/pdf" component={PDF} />
        </Switch>
      </Container>
    );
  }
}

Menu.propTypes = {
  analytics: PropTypes.object,
  dispatch: PropTypes.func,
  history: PropTypes.object,
  pwpaHasExcludeHolding: PropTypes.bool,
  check_history: PropTypes.bool,
  pwpaPortfolio: PropTypes.object,
  language: PropTypes.string,
};

Menu.defaultProps = {
  analytics: {},
  dispatch: () => false,
  history: {},
  pwpaHasExcludeHolding: false,
  check_history: true,
  pwpaPortfolio: {},
  language: 'en',
};

const Tab = styled(({ className, children, ...rest }) => (
  <NavLink className={className} {...rest}>
    {children}
  </NavLink>
))`
  display: inline-block;
  padding: 1rem 0;
  width: calc(100% / 6);
  font-size: 1rem;
  position: relative;
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
  border-left: 1px solid rgb(236, 236, 240);
  border-bottom: 1px solid rgb(236, 236, 240);

  &:first-child {
    border-left: 0;

    &.active {
      font-weight: 700;
      background: rgb(246, 246, 250);

      &:after {
        background: ${colors.red};
      }
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
  }

  &.active {
    font-weight: 700;
    background: rgb(246, 246, 250);

    &:after {
      background: ${colors.red};
    }
  }

  &:hover {
    font-weight: 700;
    color: rgba(0, 0, 0, 0.8);
  }
`;

const SubMenu = styled.ul`
  position: absolute;
  top: 0;
  right: 0;
  background: white;
  width: calc(100% / 6);
  height: ${(props) => (props.open ? 'auto' : '49px')};
  box-shadow: ${(props) => props.open && `0 3px 3px ${colors.grey}`};
  border-radius: ${(props) => props.open && '0 0 8px 8px'};
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 2;

  &:hover {
    height: ${(props) => (props.ableHover ? 'auto' : '49px')};
    box-shadow: ${(props) =>
      props.ableHover ? `0px 3px 3px ${colors.grey}` : ''};
    border-radius: ${(props) => (props.ableHover ? '0 0 8px 8px' : '0 0 0 0')};

    li:first-child {
      border: ${(props) =>
        props.ableHover
          ? '1px solid rgb(236,236,240) !important'
          : '1px solid rgb(236,236,240)'};
      border-right: none;
      border-top-right-radius: ${(props) =>
        props.ableHover ? '8px !important' : 'unset'};
      border-top: ${(props) =>
        props.ableHover ? 'transparent !important' : 'unset'};
    }
  }

  li:first-child {
    border: ${(props) =>
      props.open ? '1px solid rgb(236,236,240) !important' : 'inherit'};
    border-bottom: ${(props) =>
      props.open
        ? '1px solid rgb(236,236,240) !important'
        : '1px solid rgb(236,236,240)'};
    border-top-right-radius: ${(props) =>
      props.open ? '8px !important' : 'unset'};
    border-top: ${(props) => (props.open ? 'transparent !important' : 'unset')};
  }

  li {
    padding: 1rem 0;
    width: 100%;
    height: 49px;
    font-size: 1rem;
    position: relative;
    text-align: center;
    border-left: 1px solid rgb(236, 236, 240);
    border-bottom: 1px solid rgb(236, 236, 240);
    border-right: 1px solid rgb(236, 236, 240);
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
    }

    &.active:after {
      background: ${colors.red};
    }

    &:first-child {
      border-left: 1px solid rgb(236, 236, 240);
      border-right: 1px solid white;
    }

    &:last-child {
      border-bottom: 1px solid rgb(236, 236, 240);
      border-radius: 0 0 8px 8px;
    }

    &:hover {
      font-weight: 700;
    }

    a {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      color: rgba(0, 0, 0, 0.8) !important;
      line-height: 49px;

      &.active {
        font-weight: 700;
        background: rgb(246, 246, 250);
      }
    }
  }
`;

const Container = styled.div`
  min-height: 100%;
  background: white;
  margin: 0;
  a {
    font-weight: bold;
  }
`;
